export function loadFotoramaScript() {
  if (window) {
    const script = document.createElement('script');
    script.src = '//www.cian.ru/static/scripts/fotorama_4.6.4.1.js';

    document.body.appendChild(script);
  }
}

export function loadScripts() {
  if (window && !window.$) {
    const script = document.createElement('script');
    script.src = '//www.cian.ru/static/scripts/jquery-1.11.1.min.js';
    script.onload = loadFotoramaScript;

    document.body.appendChild(script);
  } else {
    loadFotoramaScript();
  }
}
